<template>
  <div>
    <pdf v-for="i in numPages" :key="i" :src="src" :page="i" class="p-1"></pdf>
  </div>
</template>

<script>
import pdf from "vue-pdf"

export default {
  name: "pdfViewer",
  components: {
    pdf
  },
  props: {
    pdfPreview: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      numPages: 3,
      currentPage: 0,
      pageCount: 0
    }
  },
  computed: {
    src() {
      return pdf.createLoadingTask(this.pdfPreview)
    }
  },
  methods: {
    getNumPages() {
      this.src.promise.then((pdf) => {
        this.numPages = pdf.numPages
      })
    }
  }
}
</script>
